import { Button, FormControl, Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";

const FILE_BASE_URL = process.env.REACT_APP_API_URL.replace("/api", "");


const API_URL = process.env.REACT_APP_API_URL;



function YMicroDeletion() {

    const { sample_id } = useParams();
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [deletedDocs, setDeletedDocs] = useState([]);

    const { user } = useAuth();
    ///////////////////////////
    const [showModal, setShowModal] = useState(false);
    const [password, setPassword] = useState();
    const [selectedId, setSelectedId] = useState(null);
    const [error, setError] = useState("");
    ////////////////////////////

    const [autoSaveAfterDelete, setAutoSaveAfterDelete] = useState(false);



    const [values, setValues] = useState({
        sample_id: "",
        ydata_id: "",
        a_deletion: "0",
        b_deletion: "0",
        c_deletion: "0",
        abc_deletion: "0",
        b1b3_deletion: "0",
        gr_deletion: "0",
        b2b3_deletion: "0",
        b2b4_deletion: "0",
        remark: ""
    });






    const [documents, setDocuments] = useState([{ id: Date.now(), name: "", file: null }]);
    const addRow = () => {
        setDocuments([...documents, { id: Date.now(), name: "", file: null }]);
    };
    const removeRow = (id) => {
        if (documents.length === 0) return;
        const confirmDelete = window.confirm("Do you want to delete?");


        const doc = documents.find(d => d.id === id);

        // if document already exists in DB, mark for deletion
        if (confirmDelete) {
            if (doc?.existing) {
                setDeletedDocs(prev => [...prev, doc.id]);
            }
        }
        setDocuments(documents.filter(d => d.id !== id));
    };

    const handleNameChange = (id, value) => {
        setDocuments(
            documents.map((doc) => (doc.id === id ? { ...doc, name: value } : doc))
        );
    };

    const handleFileChange = (id, file) => {
        setDocuments(
            documents.map((doc) => (doc.id === id ? { ...doc, file: file } : doc))
        );
    };

    const labelBox = {
        backgroundColor: "#DFF5F1",
        padding: "10px 20px",
        borderRadius: "8px",
        border: "2px solid #4DB6AC",
        fontWeight: "bold",
        fontSize: "16px",
        width: "260px",
        textAlign: "left"
    };

    const inputBox = {
        width: "150px",
        height: "40px",
        border: "2px solid #001A43",
        borderRadius: "6px",
        textAlign: "center",
        fontSize: "18px"
    };

    useEffect(() => {
        if (!sample_id) return;

        const fetchData = async () => {
            try {
                const res = await axios.get(
                    `${API_URL}/get-y-microdeletion/${sample_id}`
                );

                if (res.data.status) {
                    setValues(prev => ({
                        ...prev,
                        ...res.data.data,
                        sample_id: sample_id
                    }));

                    if (res.data.attachments?.length) {
                        setDocuments(
                            res.data.attachments.map(att => ({
                                id: att.att_id,
                                name: att.doc_name,
                                file: null,
                                existing: true,
                                file_path: att.file_path
                            }))
                        );
                    }
                }
            } catch (err) {
                console.error(err);
                setErrorMsg("Failed to load data");
            }
        };

        fetchData();
    }, [sample_id]);




    const handleSave = async () => {
        if (!values.ydata_id) {
            alert("Record not created yet");
            return;
        }

        try {
            const formData = new FormData();

            Object.entries(values).forEach(([k, v]) => {
                formData.append(k, v ?? "");
            });

            documents.forEach((doc, i) => {
                if (doc.file) {
                    formData.append(`documents[${i}][file]`, doc.file);
                    formData.append(`documents[${i}][name]`, doc.name);
                }
            });

            deletedDocs.forEach(id => {
                formData.append("deleted_docs[]", id);
            });

            const res = await axios.post(
                `${API_URL}/y-microdeletion-update/${values.ydata_id}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            // alert(res.data.message || "Saved successfully");

            setSuccessMsg(
                res.data.message || `Y-Microdeletion data saved successfully`
            ); setErrorMsg("");

            setTimeout(() => setSuccessMsg(""), 1000);
            setDeletedDocs([]);

        } catch (err) {
            console.error(err);
            setErrorMsg("save failed");
        }
    };




    const handleChange = (field, val) => {
        setValues(prev => ({ ...prev, [field]: val }));
    };

    const openPasswordModal = (literature_id) => {
        setSelectedId(literature_id);
        setPassword("");
        setError("");
        setShowModal(true);
    };


    const verifyPassword = async () => {
        try {
            const token = localStorage.getItem("token");

            const res = await axios.post(
                `${API_URL}/verify-password`,
                { password, uid: user?.uid },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (res.data.success) {
                setShowModal(false);

                removeRow(selectedId);
                setAutoSaveAfterDelete(true);
            } else {
                setError("Incorrect password");
            }
        } catch (err) {
            setError("Incorrect password");
        }
    };
    useEffect(() => {
        if (autoSaveAfterDelete) {
            const fakeEvent = { preventDefault: () => { } };
            handleSave(fakeEvent);   // call API
            setAutoSaveAfterDelete(false);
        }
    }, [documents]);

    return (
        <div style={{ padding: "40px", position: "relative", minHeight: "85vh" }}>
            <h6 style={{ textAlign: "left" }}>Y-Microdeletion Data</h6>

            {successMsg && (
                <div className="alert alert-success mt-2">
                    {successMsg}
                </div>
            )}

            {errorMsg && (
                <div className="alert alert-danger mt-2">
                    {errorMsg}
                </div>
            )}



            <div
                style={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "80px",
                    marginTop: "20px"
                }}
            >

                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                    <div
                        style={{
                            ...labelBox,
                            width: "420px",
                            textAlign: "center",
                            fontSize: "18px"
                        }}
                    >
                        AZF abc deletion
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelBox}>AZF a deletion</div>
                        <FormControl as="select" style={inputBox}
                            value={values["a_deletion"] || ""}
                            onChange={(e) => handleChange("a_deletion", e.target.value)}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </FormControl>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelBox}>AZF b deletion</div>
                        <FormControl as="select" style={inputBox}
                            value={values["b_deletion"] || ""}
                            onChange={(e) => handleChange("b_deletion", e.target.value)}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </FormControl>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelBox}>AZF c deletion</div>
                        <FormControl as="select" style={inputBox}
                            value={values["c_deletion"] || ""}
                            onChange={(e) => handleChange("c_deletion", e.target.value)}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </FormControl>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelBox}>AZF abc deletion</div>
                        <FormControl as="select" style={inputBox}
                            value={values["abc_deletion"] || ""}
                            onChange={(e) => handleChange("abc_deletion", e.target.value)}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </FormControl>
                    </div>

                </div>

                {/* RIGHT COLUMN */}
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

                    <div
                        style={{
                            ...labelBox,
                            width: "420px",
                            textAlign: "center",
                            fontSize: "18px"
                        }}
                    >
                        Partial AZF c deletion
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelBox}>b1/b3 deletion</div>
                        <FormControl as="select" style={inputBox}
                            value={values["b1b3_deletion"] || ""}
                            onChange={(e) => handleChange("b1b3_deletion", e.target.value)}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </FormControl>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelBox}>gr/gr deletion</div>
                        <FormControl as="select" style={inputBox}
                            value={values["gr_deletion"] || ""}
                            onChange={(e) => handleChange("gr_deletion", e.target.value)}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </FormControl>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelBox}>b2/b3 deletion</div>
                        <FormControl as="select" style={inputBox}
                            value={values["b2b3_deletion"] || ""}
                            onChange={(e) => handleChange("b2b3_deletion", e.target.value)}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </FormControl>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                        <div style={labelBox}>b2/b4 deletion</div>
                        <FormControl as="select" style={inputBox}
                            value={values["b2b4_deletion"] || ""}
                            onChange={(e) => handleChange("b2b4_deletion", e.target.value)}
                        >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </FormControl>
                    </div>

                </div>

            </div>

            <div style={{ marginTop: "40px" }}>

                <Row className="mt-4" >
                    <Col xs={12}>
                        <table className="table table-bordered table-responsive table-striped">
                            <thead>
                                <tr style={{ backgroundColor: "#DFF5F1", fontWeight: "bold" }}>
                                    <th style={{ backgroundColor: "#DFF5F1" }}>Sr.No</th>
                                    <th style={{ backgroundColor: "#DFF5F1" }}>Document Name</th>
                                    <th style={{ backgroundColor: "#DFF5F1" }}>Upload Document</th>
                                    <th style={{ backgroundColor: "#DFF5F1" }}>
                                        <Button variant="primary" size="md" onClick={addRow}>
                                            +
                                        </Button>
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {documents.map((doc, index) => (
                                    <tr key={doc.id}>
                                        <td>{index + 1}</td>

                                        <td>
                                            <Form.Select
                                                type="text"
                                                value={doc.name}
                                                onChange={(e) =>
                                                    handleNameChange(doc.id, e.target.value)
                                                }

                                            >
                                                <option value="">select</option>
                                                <option value="abc">AZF abc deletion</option>
                                                <option value="c">Partial AZF c deletion</option>
                                            </Form.Select>
                                        </td>

                                        <td>
                                            <Form.Control
                                                type="file"
                                                accept=".jpg,.jpeg,.png,.pdf,.svg"
                                                onChange={(e) =>
                                                    handleFileChange(doc.id, e.target.files[0])
                                                }
                                            />
                                            {doc.existing && doc.file_path && (
                                                <div style={{ marginTop: "5px" }}>
                                                    <a
                                                        href={`${API_URL}/documents/${doc.file_path.split('/').pop()}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        style={{ marginLeft: "10px", fontWeight: "500", color: "#007bff", textDecoration: "underline" }}
                                                    >
                                                        View File
                                                    </a>
                                                </div>
                                            )}
                                        </td>

                                        <td className="text-center">
                                            <Button
                                                variant="danger"
                                                size="md"
                                                onClick={() => openPasswordModal(doc.id)}
                                            >
                                                -
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </Col>
                </Row></div>
            <div className="mb-3">


                <FormControl
                    as="textarea"
                    rows={2}
                    placeholder="Enter remarks here"
                    value={values.remark || ""}
                    onChange={(e) => handleChange("remark", e.target.value)}
                    style={{ width: "1000px", marginTop: "30px" }}
                />

            </div>
            <div className="d-flex justify-content-center mt-4">
                <Button
                    type="submit"
                    variant="primary"
                    className="px-4 mb-4"
                    onClick={handleSave}

                >
                    Save
                </Button>
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                centered
                backdrop="static"
                keyboard={false}
                dialogClassName="soft-modal"
            >
                <Modal.Header closeButton style={{ borderBottom: "none" }}>
                    <Modal.Title style={{ fontWeight: 600, fontSize: "1.3rem" }}>
                        Confirm Password
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: "2rem 2rem 1rem 2rem" }}>
                    <Form.Group>
                        <Form.Label style={{ fontWeight: 500, fontSize: "0.95rem", color: "#555" }}>
                            Enter your password
                        </Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="" autoComplete="off"
                            style={{
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                                padding: "10px 15px",
                                fontSize: "0.95rem",
                                boxShadow: "inset 0 2px 5px rgba(0,0,0,0.05)",
                            }}
                        />
                    </Form.Group>
                    {error && (
                        <p
                            className="text-danger mt-2"
                            style={{ fontSize: "0.9rem", fontWeight: 500 }}
                        >
                            {error}
                        </p>
                    )}
                </Modal.Body>

                <Modal.Footer style={{ borderTop: "none", padding: "1rem 2rem 2rem 2rem" }}>
                    <Button
                        variant="outline-secondary"
                        onClick={() => setShowModal(false)}
                        style={{
                            borderRadius: "10px",
                            padding: "8px 18px",
                            fontWeight: 500,
                            boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        onClick={verifyPassword} autoComplete="off"
                        style={{
                            borderRadius: "10px",
                            padding: "8px 20px",
                            fontWeight: 600,
                            background: "linear-gradient(135deg,#6a9fff,#5a86ff)",
                            border: "none",
                            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                        }}
                    >
                        Verify
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default YMicroDeletion;